import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import storePersist from "../../redux/storePersist";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useNavigate } from "react-router-dom";
import { selectOrganizationUnitsListItems } from "../../redux/organizationUnits/selector";


const Header = () => {
  const navigate = useNavigate()
  const result = useSelector(selectCurrent)
  const [color, setColor] = useState('universal')
  const { header, footer, visible, sidebar, theme, primary, secondary } = result
  const [logo, setLogo] = useState<any>()
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeSubIndex, setActiveSubIndex] = useState(null);
  const organizationLists = useSelector(selectOrganizationUnitsListItems)
  const [menus, setMenus] = useState([

 

    // Start - SidebarMenu List - CMS

     {
      id: `main-menu-2-all`,
      path: '/agencies/dashboard',
      label: 'DashBoard',

      Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
      isEnabled: true,
      svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
          </g>
        </svg>

      ),
    },

    {
      id: `main-menu-2-all`,
      path: '/agencies/dbncloud/globaicommunity',
      label: 'DBN Cloud',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'Global Community',
          path: '/agencies/dbncloud/globaicommunity',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Global Events',
          path: '/agencies/dbncloud/globalevents',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),

        },
        {
          id: `coln-1-Categories`,
          label: 'Global Programs',
          path: '/agencies/dbncloud/globalprograms',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),

        },



      ],
    },


    {
      id: `main-menu-2-all`,
      path: '/agencies/community/communities',
      label: 'Connect-X',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'Communities',
          path: '/agencies/community/communities',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },


        {
          id: `coln-1-Categories`,
          label: 'Forums',
          path: '/agencies/forum/forum-group',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
          subMenu: [
            {
              id: `coln-1-Categories`,
              label: 'Groups',
              path: '/agencies/forum/forum-group',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
            {
              id: `coln-1-Categories`,
              label: 'Forums',
              path: '/agencies/forum/forums',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
            {
              id: `coln-1-Categories`,
              label: 'Topics',
              path: '/agencies/forum/forum-topics',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
            {
              id: `coln-1-Categories`,
              label: 'Posts',
              path: '/agencies/forum/forum-posts',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
            {
              id: `coln-1-Categories`,
              label: 'Subscriptions',
              path: '/agencies/forum/forum-subscriptions',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
          ],
        },

      ],
    },

    {
      id: `main-menu-2-all`,
      path: '/agencies/event/events',
      label: 'Events Management',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'Events',
          path: '/agencies/event/events',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },

        {
          id: `coln-1-Categories`,
          label: 'Tickets',
          path: '/agencies/event/event-tickets',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Booking',
          path: '/agencies/event/event-bookings',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },


      ],
    },

    {
      id: `main-menu-2-all`,
      path: '/agencies/programshub/programs',
      label: 'Program Hub',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'Programs',
          path: '/agencies/programshub/programs',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },


      ],
    },

    {
      id: `main-menu-2-all`,
      path: '/agencies/promotions/marketing/campaign',
      label: 'Promotions',

      Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
      isEnabled: true,
      svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
          </g>
        </svg>

      ),


      subMenu: [


        {
          id: `coln-1-collections`,
          label: 'Marketing',
          path: '/agencies/promotions/marketing/campaign',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
          subMenu: [

            {
              id: `coln-1-collections`,
              label: 'Campaign',
              path: '/agencies/promotions/marketing/campaign',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>

              ),
            },

              {
          id: `coln-1-collections`,
          label: 'Campaign 2.0',
          path: '/agencies/promotions/marketing/campaigns2',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
            {
              id: `coln-1-collections`,
              label: 'Plan',
              path: '/agencies/promotions/marketing/plan',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>
              ),


            },
            {
              id: `coln-1-collections`,
              label: 'Plan 2.0',
              path: '/agencies/promotions/marketing/plan2',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>
              ),
            },
            {
              id: `coln-1-collections`,
              label: 'Templates',
              path: '/agencies/promotions/marketing/templates',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>
              )

            },
            {
              id: `coln-1-collections`,
              label: 'Analyze',
              path: '/agencies/wip',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>

              ),
            },

            {
              id: `coln-1-collections`,
              label: 'SEO Engine',
              path: '/agencies/wip',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>

              ),
            },


          ],
        },

      ]

    },

    {
      id: `main-menu-2-all`,
      path: '/agencies/sales/contacts',
      label: 'Networks',

      Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
      isEnabled: true,
      svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
          </g>
        </svg>

      ),


      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'Contacts',
          path: '/agencies/sales/contacts',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },

        {
          id: `coln-1-collections`,
          label: 'One User',
          path: '/agencies/sales/oneuser',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },

        {
          id: `coln-1-collections`,
          label: 'Venture',
          path: '/agencies/sales/venture',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },


      ],
    },
    // {
    //   id: `main-menu-2-all`,
    //   path: '/agencies/policies/marketpolicy',
    //   label: 'Policies',

    //   Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
    //   isEnabled: true,
    //   svg: (
    //     <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    //       <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //       <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //       <g id="SVGRepo_iconCarrier">
    //         <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
    //         <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
    //       </g>
    //     </svg>

    //   ),


    //   subMenu: [
    //     {
    //       id: `coln-1-collections`,
    //       label: 'Marketplace Policy',
    //       path: '/agencies/policies/marketpolicy',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),
    //     },
    //     {
    //       id: `coln-1-collections`,
    //       label: 'Aggregation Policy',
    //       path: '/agencies/policies/aggregation',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),
    //     },
    //     {
    //       id: `coln-1-collections`,
    //       label: 'Order Policy',
    //       path: '/agencies/policies/orderpolicy',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),
    //     },

    //   ],
    // },
    {
      id: `main-menu-2-all`,
      path: '/agencies/cms/websites',
      label: 'CMS',

      Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
      isEnabled: true,
      svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
          </g>
        </svg>

      ),


      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'Websites',
          path: '/agencies/cms/websites',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Web Pages',
          path: '/agencies/cms/webpages',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'EDocs ',
          path: '/agencies/edocs/edocs',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Templates ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Social Profiles ',
          path: '/agencies/cms/socialprofile',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Announcements ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Topics ',
          path: '/agencies/cms/help-topics',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Blog ',
          path: '/agencies/cms/blog/blog-posts',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
          subMenu: [
            {
              id: `coln-1-collections`,
              label: 'Blog Post ',
              path: '/agencies/cms/blog/blog-posts',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>

              ),

            },
            {
              id: `coln-1-collections`,
              label: 'Comments ',
              path: '/agencies/wip',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>

              ),

            },
          ]
        },
        {
          id: `coln-1-collections`,
          label: 'News Letter ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
          subMenu: [
            {
              id: `coln-1-collections`,
              label: 'News Items ',
              path: '/agencies/wip',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>

              ),

            },
            {
              id: `coln-1-collections`,
              label: 'News Letter Comments',
              path: '/agencies/wip',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                  </g>
                </svg>

              ),

            },
          ]
        },
        {
          id: `coln-1-collections`,
          label: 'Polls ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },


      ],
    },

    // {
    //   id: `main-menu-2-all`,
    //   path: '/agencies/wip',
    //   label: 'Marketplaces',

    //   Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
    //   isEnabled: true,
    //   svg: (
    //     <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    //       <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //       <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //       <g id="SVGRepo_iconCarrier">
    //         <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
    //         <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
    //       </g>
    //     </svg>

    //   ),


    //   subMenu: [
    //     {
    //       id: `coln-1-collections`,
    //       label: 'e-Mart',
    //       path: '/agencies/wip',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),
    //       subMenu: [
    //         {
    //           id: `coln-1-collections`,
    //           label: 'Products',
    //           path: '/agencies/wip',
    //           isEnabled: true,
    //           svg: (
    //             <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //               <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //               <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //               <g id="SVGRepo_iconCarrier">
    //                 <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //               </g>
    //             </svg>

    //           ),

    //         },
    //         {
    //           id: `coln-1-collections`,
    //           label: 'Vendors',
    //           path: '/agencies/wip',
    //           isEnabled: true,
    //           svg: (
    //             <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //               <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //               <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //               <g id="SVGRepo_iconCarrier">
    //                 <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //               </g>
    //             </svg>

    //           ),

    //         },
    //       ]
    //     },
    //     {
    //       id: `coln-1-collections`,
    //       label: 'F&B',
    //       path: '/agencies/wip',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),
    //       subMenu: [
    //         {
    //           id: `coln-1-collections`,
    //           label: 'Food',
    //           path: '/agencies/wip',
    //           isEnabled: true,
    //           svg: (
    //             <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //               <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //               <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //               <g id="SVGRepo_iconCarrier">
    //                 <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //               </g>
    //             </svg>

    //           ),

    //         },
    //         {
    //           id: `coln-1-collections`,
    //           label: 'Restaurants',
    //           path: '/agencies/wip',
    //           isEnabled: true,
    //           svg: (
    //             <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //               <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //               <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //               <g id="SVGRepo_iconCarrier">
    //                 <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //               </g>
    //             </svg>

    //           ),

    //         },
    //       ]
    //     },
    //     {
    //       id: `coln-1-collections`,
    //       label: 'Instamart ',
    //       path: '/agencies/wip',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),

    //       subMenu: [
    //         {
    //           id: `coln-1-collections`,
    //           label: 'InstaProducts ',
    //           path: '/agencies/wip',
    //           isEnabled: true,
    //           svg: (
    //             <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //               <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //               <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //               <g id="SVGRepo_iconCarrier">
    //                 <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //               </g>
    //             </svg>

    //           ),

    //           subMenu: []
    //         },
    //         {
    //           id: `coln-1-collections`,
    //           label: 'Shops ',
    //           path: '/agencies/wip',
    //           isEnabled: true,
    //           svg: (
    //             <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //               <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //               <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //               <g id="SVGRepo_iconCarrier">
    //                 <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //               </g>
    //             </svg>

    //           ),

    //           subMenu: []
    //         },
    //       ]
    //     },
    //     {
    //       id: `coln-1-collections`,
    //       label: 'Subscriptions ',
    //       path: '/agencies/wip',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),
    //     },
    //     {
    //       id: `coln-1-collections`,
    //       label: 'Gift Cards',
    //       path: '/agencies/wip',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),
    //     },
    //     {
    //       id: `coln-1-collections`,
    //       label: 'Offers ',
    //       path: '/agencies/wip',
    //       isEnabled: true,
    //       svg: (
    //         <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    //           <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    //           <g id="SVGRepo_iconCarrier">
    //             <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
    //           </g>
    //         </svg>

    //       ),
    //     },

    //   ],
    // },

    {
      id: `main-menu-2-all`,
      path: '/agencies/wip',
      label: 'Configurations',

      Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
      isEnabled: true,
      svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
          </g>
        </svg>

      ),


      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'SMS',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),

        },
        {
          id: `coln-1-collections`,
          label: 'WhatsApp',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),

        },
        {
          id: `coln-1-collections`,
          label: 'DCM ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),


        },

        {
          id: `coln-1-collections`,
          label: 'Email ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },

        {
          id: `coln-1-collections`,
          label: 'FaceBook ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Storage ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'CDN ',
          path: '/agencies/wip',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
        },

      ],
    },

   
  ]
  )
  const fetchLogo = () => {

    const storeData = {
      logoDark: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Light'
      }),
      logoLight: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Dark'
      }),
      storeName: organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
      description: organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
      favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/images/logo.png'
    }
    setLogo(storeData)
  }

  const handleNavigate = (data: any) => {
    navigate(`${data}`)
  }
  const handleItemClick = (index: any) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const handleSubItemClick = (index: any) => {
    setActiveSubIndex(index === activeSubIndex ? null : index);
  };
  useEffect(() => {
    if (storePersist?.get("organizationUnits")?.isSuccess) {
      fetchLogo()
    }
  }, [])

  // useEffect(() => {
  //   setColor(theme)
  // }, [theme]);

  const dispatch = useAppDispatch();

  const handleSideBarView = () => {
    dispatch(settings.set({ sidebar: !sidebar }))
  }
  const handleProfile = () => {
    navigate('/dsap-agency/profile')
    // dispatch(user.set({ viewProfile: 'open' }))
  }
  useEffect(() => {
    const favicon: any = document.getElementById("favicon");
    if (favicon) {
      favicon.href = logo?.favicon;
    }
    ;
  }, [logo]);

  return (
    <>
      <div className="sticky top-0 z-[1000]">
        <div className={`w-full h-20 p-5 flex items-center justify-between bg-primary text-light`}>
          <div className="flex">
            <div className="flex items-center mr-4">
              <div className={`${sidebar ? "ml-8" : ""}`}>
                {sidebar ? <>{logo && logo?.logoDark?.length > 0 && <img src={logo?.logoDark[0]?.Url} className="w-32 h-12 " />}</> : <>{logo && logo?.logoDark?.length > 0 && <img src={logo?.logoDark[0]?.Url} className="w-16 h-8 " />}</>}
              </div>
             
            </div>
          </div>
          <div className="flex items-center ">
            <ol>
              <li className="hoverable flex items-start  ">
                <div className="relative block py-6 px-4 lg:p-6 text-sm  font-bold hover:bg-secondary  hover:text-blue-500">
                  <svg width="24" height="24" className=" text-white" viewBox="0 0 24 24" fill="none">
                    <path stroke="#ffffff" stroke-width="2" d="M4 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5ZM14 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5ZM4 16a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3ZM14 13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-6Z" />
                  </svg>
                </div>
                <div className="mega-menu mt-16 p-2 shadow-xl bg-secondary">
                  <div className="container w-full flex flex-wrap justify-start mx-2">
                    {menus.map((menuData: any, index: any) => (
                      <ul className="px-4 w-full sm:w-1/2 lg:w-1/4 border-gray-600 border-b sm:border-r lg:border-b-0">
                        <div
                          onClick={() => handleItemClick(index)}
                          className="flex items-center justify-start cursor-pointer my-2">
                          {/* <svg className="h-5  mr-3 fill-current text-white"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z" />
                          </svg> */}
                          {menuData?.svg}
                          <span className="hover:text-yellow-400 w-36 text-sm" onClick={()=>handleNavigate(menuData?.path)}>{menuData?.label}</span>
                          {activeIndex !== index ? <svg fill="#FFFFFF" height="14" width="14" version="1.1" id="Layer_1" viewBox="0 0 330 330">
                            <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
C255,161.018,253.42,157.202,250.606,154.389z"/>
                          </svg> :
                            <svg fill="#FFFFFF" height="14" width="14" version="1.1" id="Layer_1" viewBox="0 0 330 330">
                              <path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/>
                            </svg>}
                        </div>
                        {menuData?.subMenu && activeIndex === index && (
                          <ul className={`flex flex-col items-center justify-start text-sm pl-10 ${activeIndex !== index ? 'hidden' : ''}`}>
                            {menuData?.subMenu.map((subMenuData: any, subMenuindex: any) => (
                              <>
                                <div onClick={() => handleSubItemClick(subMenuindex)} className="flex w-full text-left cursor-pointer my-1">
                                  {/* <svg className="h-5  mr-3 fill-current text-white"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z" />
                                  </svg> */}
                                  {subMenuData?.svg}
                                  <h3 className=" text-md text-white px-2" onClick={() => handleNavigate(subMenuData?.path)}>	<a className="text-light hover:text-yellow-400">{subMenuData?.label}</a>
                                  </h3>
                                  {subMenuData?.subMenu ? (activeSubIndex !== subMenuindex ? <svg className="mt-1" fill="#FFFFFF" height="14" width="14" version="1.1" id="Layer_1" viewBox="0 0 330 330">
                                    <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
C255,161.018,253.42,157.202,250.606,154.389z"/>
                                  </svg> :
                                    <svg className="mt-1" fill="#FFFFFF" height="14" width="14" version="1.1" id="Layer_1" viewBox="0 0 330 330">
                                      <path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/>
                                    </svg>) : ''}
                                </div>
                                {subMenuData?.subMenu && activeSubIndex === subMenuindex && (
                                  <ul className={`w-full flex-col items-center justify-start text-sm pl-10 ${activeSubIndex !== subMenuindex ? 'hidden' : ''}`}>
                                    {subMenuData?.subMenu.map((functionData: any, functionIndex: any) => (
                                      <>
                                        <div className="flex w-full text-left cursor-pointer my-2">
                                          {/* <svg className="h-5  mr-3 fill-current text-white"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z" />
                                          </svg> */}
                                          {functionData?.svg}
                                          <h3 className=" text-md text-white px-2" onClick={() => handleNavigate(functionData?.path)}>
                                            <a className="text-light hover:text-yellow-400" >{functionData?.label}</a>
                                          </h3>
                                        </div>
                                      </>
                                    ))}
                                  </ul>
                                )}
                              </>
                            ))}
                          </ul>
                        )}
                      </ul>
                    ))}
                  </div>
                </div>
              </li>
            </ol>
            <div className="px-3 pl-0">
            {Notification.permission === 'granted' ?
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.04283 5.1757C8.59546 4.75121 9.24946 4.43224 10.0136 4.23441C10.0046 4.15752 10 4.0793 10 4C10 2.89543 10.8955 2 12 2C13.1046 2 14 2.89543 14 4C14 4.0793 13.9954 4.15752 13.9864 4.23441C14.7506 4.43224 15.4046 4.75121 15.9572 5.1757C16.933 5.92519 17.4981 6.93095 17.8325 7.93362C18.1644 8.92891 18.2842 9.96595 18.3426 10.8395C18.3663 11.1941 18.3806 11.5351 18.3932 11.8357L18.4018 12.0385C18.4175 12.3994 18.433 12.6684 18.4596 12.8673C18.6553 14.329 18.8982 15.3543 19.2438 16.1741C19.5816 16.9754 20.0345 17.6202 20.7071 18.2929C20.9931 18.5789 21.0787 19.009 20.9239 19.3827C20.7691 19.7564 20.4045 20 20 20H13.7325C13.9026 20.2942 14 20.6357 14 21C14 22.1046 13.1046 23 12 23C10.8955 23 10 22.1046 10 21C10 20.6357 10.0974 20.2942 10.2676 20H4.00003C3.59557 20 3.23093 19.7564 3.07615 19.3827C2.92137 19.009 3.00692 18.5789 3.29292 18.2929C3.96694 17.6189 4.4186 16.9787 4.75553 16.1809C5.1004 15.3642 5.3434 14.3395 5.54043 12.8673C5.56706 12.6684 5.58255 12.3994 5.59827 12.0385L5.60687 11.8357C5.61945 11.5351 5.63371 11.1941 5.65744 10.8395C5.7159 9.96595 5.83561 8.92891 6.16756 7.93362C6.50196 6.93095 7.06705 5.92519 8.04283 5.1757ZM6.06869 18C6.26568 17.6741 6.44135 17.3298 6.59797 16.959C7.04284 15.9056 7.31562 14.6803 7.52276 13.1327C7.56305 12.8316 7.58113 12.4756 7.59638 12.1255L7.60555 11.9095C7.61808 11.6105 7.63109 11.3002 7.65298 10.973C7.70745 10.159 7.81312 9.32109 8.06482 8.56638C8.31407 7.81905 8.6909 7.19981 9.26113 6.7618C9.82482 6.32883 10.6723 6 12 6C13.3278 6 14.1752 6.32883 14.7389 6.7618C15.3092 7.19981 15.686 7.81905 15.9352 8.56638C16.1869 9.32109 16.2926 10.159 16.3471 10.973C16.369 11.3002 16.382 11.6105 16.3945 11.9095L16.3945 11.9095L16.3945 11.9096L16.4037 12.1255C16.4189 12.4756 16.437 12.8316 16.4773 13.1327C16.6832 14.671 16.956 15.8957 17.4008 16.9509C17.5583 17.3244 17.735 17.6714 17.9334 18H6.06869Z" fill="#ffffff"></path> </g></svg> :
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M14 4C14 4.0793 13.9954 4.15752 13.9864 4.23441C14.6078 4.39529 15.1564 4.63627 15.6368 4.94896L14.1699 6.41585C13.6414 6.16531 12.9414 6 12 6C10.6723 6 9.82479 6.32883 9.2611 6.7618C8.69087 7.19981 8.31404 7.81905 8.06479 8.56638C7.81309 9.32109 7.70742 10.159 7.65295 10.973C7.63106 11.3002 7.61806 11.6104 7.60552 11.9094L7.60552 11.9095V11.9095L7.59635 12.1255C7.58242 12.4452 7.56614 12.7698 7.53273 13.0531L4.96511 15.6207C5.20312 14.9011 5.3859 14.0218 5.5404 12.8673C5.56703 12.6684 5.58253 12.3994 5.59824 12.0385L5.60684 11.8357L5.60684 11.8357L5.60684 11.8357C5.61942 11.5351 5.63369 11.1941 5.65742 10.8395C5.71587 9.96595 5.83559 8.92891 6.16753 7.93362C6.50193 6.93095 7.06702 5.92519 8.0428 5.1757C8.59543 4.75121 9.24943 4.43224 10.0136 4.23441C10.0046 4.15752 10 4.0793 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4ZM12 23C13.1046 23 14 22.1046 14 21C14 20.6357 13.9026 20.2942 13.7324 20H20C20.4045 20 20.7691 19.7564 20.9239 19.3827C21.0787 19.009 20.9931 18.5789 20.7071 18.2929C20.0344 17.6202 19.5816 16.9754 19.2438 16.1741C18.8982 15.3543 18.6552 14.329 18.4596 12.8673C18.433 12.6684 18.4175 12.3994 18.4018 12.0385L18.3932 11.8357C18.3806 11.5351 18.3663 11.1941 18.3426 10.8395C18.3098 10.3503 18.2579 9.80975 18.1602 9.25401L16.3528 11.0614C16.3713 11.3562 16.3831 11.6374 16.3945 11.9094L16.3945 11.9096L16.3945 11.9096L16.4037 12.1255C16.4189 12.4756 16.437 12.8316 16.4773 13.1327C16.6832 14.671 16.956 15.8957 17.4008 16.9509C17.5582 17.3244 17.735 17.6714 17.9333 18H9.41422L7.41422 20H10.2676C10.0974 20.2942 10 20.6357 10 21C10 22.1046 10.8954 23 12 23ZM19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L2.29289 20.2929C1.90237 20.6834 1.90237 21.3166 2.29289 21.7071C2.68342 22.0976 3.31658 22.0976 3.70711 21.7071L19.7071 5.70711Z" fill="#ffffff"></path> </g></svg>}
            </div>
            <div className="px-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ffffff" viewBox="0 0 256 256"><path d="M201.89,54.66A103.43,103.43,0,0,0,128.79,24H128A104,104,0,0,0,24,128v56a24,24,0,0,0,24,24H64a24,24,0,0,0,24-24V144a24,24,0,0,0-24-24H40.36A88.12,88.12,0,0,1,190.54,65.93,87.39,87.39,0,0,1,215.65,120H192a24,24,0,0,0-24,24v40a24,24,0,0,0,24,24h24a24,24,0,0,1-24,24H136a8,8,0,0,0,0,16h56a40,40,0,0,0,40-40V128A103.41,103.41,0,0,0,201.89,54.66ZM64,136a8,8,0,0,1,8,8v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V136Zm128,56a8,8,0,0,1-8-8V144a8,8,0,0,1,8-8h24v56Z"></path></svg>
            </div>
            <a onClick={() => handleNavigate('/agencies/profile')}>
              <img src={require('./../../assets/img/avathar.png')} className="mx-2 w-12 h-12 rounded-full shadow-lg" />
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
export default Header;